


export enum InformationSources {
    Tenant = 0,
    Member = 1,
    Geocode = 2
}
